export default __webpack_public_path__ + "static/media/img-proj-scb-anywhere.5cc04fd1.png";